import { Component, Input } from '@angular/core';

import { ExtDocument } from '../../scripts/extDocument';
import { makeComplexConfigItem } from '../../scripts/table-configs/table-config-helpers';
import { ITableLikeLayoutEvent } from '../table-like-layout/table-like-layout.component';

@Component({
  selector: 'timesheet-headers',
  templateUrl: './timesheet-headers.component.html',
  standalone: false,
})
export class TimesheetHeadersComponent {
  @Input() public timesheets: ExtDocument[] = [];

  public getHeaders(timesheet: ExtDocument) {
    if (timesheet.headerConfig.length > 0) return timesheet.headerConfig;
    return [
      makeComplexConfigItem(`No Headers`, 'Description', 'left-text', 1, false, true, {
        hasInlineLabel: true,
        class: 'h-full',
      }),
    ];
  }

  public handleValueChanged(event: ITableLikeLayoutEvent<ExtDocument>): void {
    event.entity.updateSelf();
  }
}
